import { render, staticRenderFns } from "./ui-toggle.vue?vue&type=template&id=08715ebb&scoped=true&"
import script from "./ui-toggle.vue?vue&type=script&lang=js&"
export * from "./ui-toggle.vue?vue&type=script&lang=js&"
import style0 from "./ui-toggle.vue?vue&type=style&index=0&id=08715ebb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08715ebb",
  null
  
)

export default component.exports